export const SET_TASK_OVERVIEW = 'SET_TASK_OVERVIEW';
export const RESET_TASK_OVERVIEW = 'RESET_TASK_OVERVIEW';
export const TASK_OVERVIEW_IS_LOADING = 'TASK_OVERVIEW_IS_LOADING';
export const TASK_OVERVIEW_ERROR = 'TASK_OVERVIEW_ERROR';
